import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table'
import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function PKeyword(){
  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>

<Helmet>
 
  <title>Learn Free Python Keywords Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python python keyword tutorial for beginners.These keywords cannot be used as identifiers,they cannot be used as names for a variable, class, or method" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python keyword,python keywords,python in keyword,python keyword arguments
,python keywords list,python keyword list,python keyword extraction,python keyword can't be an expression,python this keyword" />
<link rel="canonical" href="https://www.codeexampler.com/python-keywords" />
</Helmet>


<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python Keywords</h1>

    <div className="first">
        <a href="/python-identifiers">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-input">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <h2 className="mt-4 mh2">Keywords in Python programming language
</h2>
<p className="mt-3 para">1,These keywords cannot be used as identifiers. Keywords do not use as a name for a variable, class, or method<br/>
2, python Programming keywords are Known as <span className="bold"> Reserved Words.</span></p>

<h3 className="mt-4 mh3">Keywords Table in Python programming language</h3>
    <Table responsive striped bordered hover variant="dark m-3">
 
  <tbody>
    <tr>
      <td></td>
      <td>None</td>
      <td>and</td>
      <td>assert</td>
      <td>False</td>
      <td>True</td>
      <td>as</td>
      <td>async</td>
    </tr>
    <tr>
      <td></td>
      <td>break</td>
      <td>continue</td>
      <td>del</td>
      <td>await</td>
      <td>class</td>
      <td>def</td>
      <td>elif</td>
    </tr>
    <tr>
      <td></td>
      <td>else</td>
      <td>finally</td>
      <td>from</td>
      <td>if</td>
      <td>except</td>
      <td>for</td>
      <td>global</td>
    </tr>

    <tr>
      <td></td>
      <td>in</td>
      <td>lambda</td>
      <td>not</td>
      <td>import</td>
      <td>is</td>
      <td>nonlocal</td>
      <td>or</td>
    </tr>

    <tr>
      <td></td>
      <td>raise</td>
      <td>try</td>
      <td>with</td>
      <td>pass</td>
      <td>return</td>
      <td>while</td>
      <td>yield</td>
    </tr>
  </tbody>
</Table>
  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/python-identifiers">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-input">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default PKeyword;